import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ProtectedRouteType } from "../Interface/Index";
import { useAuth } from "../Context/AuthContext/AuthContext";
import AuthService from "../Services/auth.service";

const ProtectedRoute: React.FC<ProtectedRouteType> = ({ children }) => {
  const navigate = useNavigate();
  const { isUserLoggedIn } = useAuth();
  const user = AuthService.getInstance().getCurrentUser();
  const location = useLocation();
  const currentPath = location.pathname + location.search;

  useEffect(() => {
    if (!user || !isUserLoggedIn) {
      navigate(`/sign-in?redirect_url=${encodeURIComponent(currentPath)}`);
    }
  }, [user, isUserLoggedIn, currentPath, navigate]);

  return <>{isUserLoggedIn ? children : null}</>;
};

export default ProtectedRoute;
